<template>

    <!-- <b-form-group > -->
      <!-- <b-form-checkbox-group
            :options="options"
            text-field="name"
            :value="myValue"
            :checked = "value"
            @change="updateValue"
            @input="inputValue"
            >
      </b-form-checkbox-group> -->
<span>
    <b-form-checkbox 
            v-model="myValue"
            :value="true"
            :unchecked-value="false"
            :disabled="disabled"
            >
            {{label}}
    </b-form-checkbox>
    <!-- myValue:{{myValue}} value:{{value}} -->
</span>
    <!-- </b-form-group> -->

</template>


<script>
export default {
    
    data(){
        return { myValue:false }
    },
    
    created:function(){
        this.myValue = this.value;
    },

     watch:{
        value:function(val){
            this.myValue = val;
        },
        myValue:function(val){
            this.$emit('change',val)
            this.$emit('input',val)
        }
    },
    
    props:{
        options:{
            type:Array,
            default:()=>[]
        },
        value:{
            type:Boolean,
            default:false
        },
        name:{
            type:String,
            default:''
        },
        label:{
            type:String,
            default:''
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
   
    computed:{
    },

    methods:{
         updateValue:function(val){
            this.myValue = val;
            
            this.$emit('change',val)
            this.$emit('input',val)
        },
         inputValue:function(val){
            this.myValue = val
            this.$emit('input',val)
        },

    }
}
</script>

<style>

</style>
